import React from 'react';
import PropTypes from 'prop-types';
import { InputGroup } from '@storable/canaveral-components';
import style from './OGTagInput.scss';

const propTypes = {
  property: PropTypes.string,
  readOnlyProperty: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  content: PropTypes.string,
  placeholder: PropTypes.string,
  readOnlyContent: PropTypes.bool,
};

const defaultProps = {};

const OGTagInput = ({
  property,
  readOnlyProperty,
  onChange,
  content,
  placeholder,
  readOnlyContent,
}) => {
  const updateTag = (e) => {
    onChange({ property, content: e.target.value });
  };

  const propertyProps = {
    type: 'text',
    disabled: readOnlyProperty,
    value: property,
  };

  const contentProps = {
    type: 'text',
    onChange: updateTag,
    value: content,
    placeholder,
    disabled: readOnlyContent,
  };

  return (
    <div className={style.container}>
      <span className={style.label}>
        Meta Property
      </span>
      <InputGroup className={style.property}>
        <InputGroup.Text {...propertyProps} />
      </InputGroup>
      <span className={style.label}>
        Content
      </span>
      <InputGroup className={style.content}>
        <InputGroup.Text {...contentProps} />
      </InputGroup>
    </div>
  );
};

OGTagInput.propTypes = propTypes;
OGTagInput.defaultProps = defaultProps;

export default OGTagInput;
